import Vue from "vue";
import JsonViewer from "vue-json-viewer";

Vue.use(JsonViewer);
